import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton,
  InputAdornment,
  Popover,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import ActionMenuItem from 'src/views/management/ChatView/NewMessage/ActionMenuItem';
import { ReactComponent as DynamicFieldsIcon } from 'src/assets/images/dynamic-fields-icon.svg';
import { STYLE_OPTIONS } from 'src/constants';

const inputAdornmentStyle = {
  padding: 0,
  color: '#B5B5B5',
  background: '#EEEEEE',
  '&:hover svg': STYLE_OPTIONS.SVG_COLOR_BLUE,
};

function InputStartAdornment({
  handleOpenPopover,
  handleClosePopover,
  popoverAnchorEl,
  isLoading,
  isAdditionalActionsDisabled,
  isScheduleDisabled,
  openUploadDialog,
  openMessageTemplateDialog,
  openDynamicFieldsDialog,
  openScheduleDialog,
}) {
  return (
    <>
      <InputAdornment
        position="start"
        sx={{
          margin: 'auto 8px 11px 0px',
        }}
      >
        <IconButton
          size="small"
          onClick={handleOpenPopover}
          disabled={isLoading || isAdditionalActionsDisabled}
          sx={{
            ...inputAdornmentStyle,
          }}
        >
          <AddIcon
            sx={{
              color: popoverAnchorEl ? STYLE_OPTIONS.SVG_COLOR_BLUE : '#B5B5B5',
            }}
          />
        </IconButton>
      </InputAdornment>
      <Popover
        open={!!popoverAnchorEl}
        anchorEl={popoverAnchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          root: {
            sx: {
              '& .MuiMenuItem-root': {
                padding: '8px 6px',
                borderRadius: '4px',
                marginBottom: '4px',
                '&:last-child': { marginBottom: 0 },
              }
            }
          },
          paper: {
            sx: {
              borderRadius: '12px',
              padding: '8px'
            }
          }
        }}
      >
        {openUploadDialog && (
          <ActionMenuItem
            disabled={isLoading}
            onClick={openUploadDialog}
            icon={<AttachFileIcon fontSize="small" />}
            label="Attach file"
          />
        )}
        {openMessageTemplateDialog && (
          <ActionMenuItem
            disabled={isLoading}
            onClick={openMessageTemplateDialog}
            icon={<MessageOutlinedIcon fontSize="small" />}
            label="Message template"
          />
        )}
        {openDynamicFieldsDialog && (
          <ActionMenuItem
            disabled={isLoading}
            onClick={openDynamicFieldsDialog}
            icon={<DynamicFieldsIcon fontSize="small" />}
            label="Dynamic fields"
          />
        )}
        {openScheduleDialog && (
          <ActionMenuItem
            disabled={isScheduleDisabled || isLoading}
            onClick={openScheduleDialog}
            icon={<ScheduleSendIcon fontSize="small" />}
            label="Schedule a message"
          />
        )}
      </Popover>
    </>
  );
}

InputStartAdornment.propTypes = {
  handleOpenPopover: PropTypes.func.isRequired,
  handleClosePopover: PropTypes.func.isRequired,
  popoverAnchorEl: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.object,
  ]),
  isLoading: PropTypes.bool,
  isAdditionalActionsDisabled: PropTypes.bool,
  isScheduleDisabled: PropTypes.bool,
  openUploadDialog: PropTypes.func,
  openMessageTemplateDialog: PropTypes.func,
  openDynamicFieldsDialog: PropTypes.func,
  openScheduleDialog: PropTypes.func,
};

InputStartAdornment.defaultProps = {
  isLoading: false,
  isAdditionalActionsDisabled: false,
  isScheduleDisabled: false,
};

export default InputStartAdornment;
